import { CompletedProgrammeWorkout, ProgrammeWorkout } from 'src/dao/core-dao'

export type ProgrammeWorkoutProgressDerived = {
  completedClassesCount: number
  totalClassesCount: number
  nextIncompleteProgrammeWorkout: ProgrammeWorkout | undefined
  nextIncompleteClassTitle: string | undefined
  nextIncompleteWorkoutId: string | undefined
  nextIncompleteWeek: number | undefined
}

/**
 * Pure completion + “next incomplete” logic shared by progress and next-workout hooks.
 */
export const deriveProgrammeWorkoutProgress = (
  programmeWorkouts: ProgrammeWorkout[],
  completedProgrammeWorkouts: CompletedProgrammeWorkout[],
): ProgrammeWorkoutProgressDerived => {
  const totalClassesCount = programmeWorkouts.length
  const completedIds = new Set(completedProgrammeWorkouts.map((cpw) => cpw.programmeWorkout.id))
  /** Match schedule order: week tab first, then order within week (sorting by `order` alone mixes weeks). */
  const sorted = [...programmeWorkouts].sort((a, b) => {
    if (a.onWeek !== b.onWeek) {
      return a.onWeek - b.onWeek
    }
    return a.order - b.order
  })
  const nextIncomplete = sorted.find((pw) => !completedIds.has(pw.id))
  const completedClassesCount = programmeWorkouts.filter((pw) => completedIds.has(pw.id)).length
  return {
    completedClassesCount,
    totalClassesCount,
    nextIncompleteProgrammeWorkout: nextIncomplete,
    nextIncompleteClassTitle: nextIncomplete?.workout?.title,
    nextIncompleteWorkoutId: nextIncomplete?.workout?.id,
    nextIncompleteWeek: nextIncomplete?.onWeek,
  }
}
